/**
 * Utilitário para normalizar URLs de embed
 * Converte URLs padrão de plataformas de vídeo para formato de incorporação (iframe)
 * 
 * RELEASE: 1.0.0 - 2026-03-09 - Normalização automática de URLs de embed
 */

/**
 * Normaliza URLs de plataformas populares para formato de embed (iframe)
 * - YouTube: watch?v=ID ou youtu.be/ID → youtube.com/embed/ID
 * - Vimeo: vimeo.com/ID → player.vimeo.com/video/ID
 * - Outros: retorna URL original sem alteração
 */
export function normalizeEmbedUrl(url: string): string {
  if (!url) return url;

  // YouTube: watch?v=ID, youtu.be/ID, shorts/ID
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([^&\s?#]+)/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;

  // YouTube: já é embed, retorna como está
  if (url.includes('youtube.com/embed/')) return url;

  // Vimeo: vimeo.com/ID → player.vimeo.com/video/ID
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;

  // Outros (Google Maps, PDFs, sites): retorna sem alteração
  return url;
}
